import { Badge, Card, Icon } from '../../../shared/ui/Primitives';
import type { Page01Snapshot } from '../adapters/demo-reader';

export function ReadinessPanels({ snapshot }: { snapshot: Page01Snapshot }) {
  const unknown = snapshot.assessment === 'unknown';
  return (
    <>
      <Card
        zone="Z05"
        title="队伍与资源准备情况"
        extra={<span className="p01-muted">准备率为示例评估</span>}
      >
        <div className="p01-four-grid">
          {snapshot.data.readiness.map((item) => (
            <article key={item.label} className="p01-readiness">
              <div className="p01-inner-title">
                <span className="p01-icon-disc">
                  <Icon name={item.icon} />
                </span>
                <h3>{item.label}</h3>
              </div>
              <div className="p01-readiness-body">
                <div>
                  <strong className="p01-number">{unknown ? '—' : `${item.value}%`}</strong>
                  {unknown ? (
                    <p>待评估</p>
                  ) : (
                    <div
                      className="p01-meter"
                      role="img"
                      aria-label={`${item.label} ${item.value}%（示例）`}
                    >
                      <span style={{ width: `${item.value}%` }} />
                    </div>
                  )}
                </div>
                {unknown ? (
                  <p className="p01-muted">尚未获得可用评估资料</p>
                ) : (
                  <dl>
                    {item.detail.map(([label, value]) => (
                      <div key={label}>
                        <dt>{label}</dt>
                        <dd>{value}</dd>
                      </div>
                    ))}
                  </dl>
                )}
              </div>
            </article>
          ))}
        </div>
      </Card>
      <Card zone="Z06" title="场景准备状态">
        <div className="p01-four-grid">
          {snapshot.data.scenarios.map((item) => (
            <article className="p01-scenario" key={item.name}>
              <div className="p01-inner-title">
                <span className="p01-icon-disc">
                  <Icon name={item.icon} />
                </span>
                <div>
                  <h3>{item.name}</h3>
                  {item.value === null ? (
                    <Badge>规划展示</Badge>
                  ) : (
                    <>
                      <strong className="p01-number">{unknown ? '—' : `${item.value}%`}</strong>
                      <span className="p01-muted">{unknown ? '待评估' : '示例评估'}</span>
                    </>
                  )}
                </div>
              </div>
              <p className="p01-muted">
                {item.value === null
                  ? '准备评估尚未确认'
                  : unknown
                    ? '尚未获得可用评估资料'
                    : '预案资料 · 演练记录 · 能力要求'}
              </p>
            </article>
          ))}
        </div>
      </Card>
    </>
  );
}
